module.exports = __webpack_public_path__ + "static/media/SR105-W1L1-P10S Copy.c74ebd92.png";